import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import StyledTabs from '@base/Tabs/Tabs';
import Tab from '@material-ui/core/Tab';
import { Spacings, mediaQuery } from '@styles/index';

const TabContainer = styled(StyledTabs)`
  position: sticky;
  top: ${Spacings.SPACING_0B};
  z-index: 4;
  margin-top: -${Spacings.SPACING_17B};
  border: ${Spacings.SPACING_0B};
  background: var(--color-base-1);
  grid-column: span 16;
  grid-row: 1/2;
  ${mediaQuery.uptoMobile} {
    width: 100%;
  }
  .MuiTabs-indicator {
    border-radius: 5px 5px 0 0;
  }
  .MuiTab-textColorInherit {
    color: var(--color-text-primary);
  }
  .Mui-selected {
    color: var(--color-text-primary);
  }
  .MuiTab-root {
    padding: ${Spacings.SPACING_6} ${Spacings.SPACING_0B};
    .MuiTab-wrapper {
      padding-top: ${Spacings.SPACING_4B};
      letter-spacing: normal !important;
    }
    ${mediaQuery.uptoMobile} {
      padding: ${Spacings.SPACING_0B};
    }
    ${mediaQuery.uptoTablet} {
      padding-top: ${Spacings.SPACING_0B};
    }
  }
`;

const StyledTab = styled(Tab)`
  &.MuiButtonBase-root {
    width: max-content;
    min-width: unset;
    margin-right: ${Spacings.SPACING_12B};
    margin-bottom: ${Spacings.SPACING_4B};
    ${mediaQuery.uptoMobile} {
      margin-right: ${Spacings.SPACING_9B};
      margin-bottom: ${Spacings.SPACING_1B};
    }
    ${mediaQuery.uptoTablet} {
      margin-bottom: ${Spacings.SPACING_2B};
    }
  }
`;

const PFTabs = ({ tabData = [], selectedTab, handleChange }) => {
  return (
    <TabContainer
      aria-label=" platform goal tabs"
      value={selectedTab}
      $selectedTabColor="var(--color-base-fill)"
      variant="scrollable"
      scrollButtons={false}
    >
      {tabData.map((item) => {
        return (
          <StyledTab
            label={item.label}
            key={item.id}
            value={item.id}
            disableRipple
            role={`tab-${item.key}`}
            onClick={() => handleChange(item)}
          />
        );
      })}
    </TabContainer>
  );
};

export default PFTabs;

PFTabs.propTypes = {
  handleChange: PropTypes.func.isRequired,
  selectedTab: PropTypes.bool.isRequired,
  tabData: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.any)).isRequired
};
